<template>
	<ul class="advert-card__icons" :class="customClass">
		<li v-for="icon in icons">
			<img
					:alt="icon.name"
					:src="icon.path"
			/>
			<span>{{ icon.name }}</span>
		</li>
	</ul>
</template>
<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
	name: "AdvertIconComponent",
	props: {
		customClass: {
			required: false,
		},
		icons: {
			type: Array,
			default: [],
			required: true,
		}
	}
})
</script>
<style scoped>

</style>
